export const categories = [
  { key: "appearanceRating", label: "Appearance" },
  { key: "bearingRating", label: "Bearing" },
  { key: "expressionRating", label: "Expression" },
  { key: "jobKnowledgeRating", label: "Job Knowledge" },
  { key: "motivationRating", label: "Motivation" },
  { key: "personalityRating", label: "Personality" },
];

export const descriptions = [
  {
    value: "1",
    text: [
      "Indifferent to attire and grooming, sloppy, Unkept",
      "No bearing, Lacks confidence, slovenly Posture",
      "Uncommunicative, confused thoughts, poor vocabulary",
      "None as pertains to this position",
      "None, Apathetic, Indifferent, Disinterested",
      "Unpleasant",
    ],
  },
  {
    value: "2",
    text: [
      "Careless attire, poor grooming",
      "Often appears uncertain, poor posture",
      "Poor speaker, hazy thoughts and ideas",
      "Will need considerable training",
      "Doubtful interest in position",
      "Slightly objectionable",
    ],
  },
  {
    value: "3",
    text: [
      "Functional attire, Neatly groomed",
      "Holds self well, seems confident",
      "Speaks well, expresses ideas adequately",
      "Basic, but will learn on",
      "Sincere desire to work",
      "Likeable",
    ],
  },
  {
    value: "4",
    text: [
      "Well groomed",
      "Sure of self, reflects confidence",
      "Speaks, thinks clearly with confidence",
      "Well versed in position, little training needed",
      "Strong interest in position, ask questions",
      "Pleasing",
    ],
  },
  {
    value: "5",
    text: [
      "Immaculate attire & grooming",
      "Highly confident, inspires others, asserts presence",
      "Exceptional, speaks clearly, concisely with confidence, ideas well thought out",
      "Extremely well versed, able to work without further training",
      "Highly motivated, Eager to work, Ask many questions",
      "Extremely pleasing, Charming individual",
    ],
  },
];

export const ratingCategories = [
  { label: "Unsatisfactory", range: [1, 15] },
  { label: "Marginal", range: [16, 18] },
  { label: "Satisfactory", range: [19, 21] },
  { label: "Very Good", range: [22, 25] },
  { label: "Excellent", range: [26, 30] },
];
